import { ThemeOptions } from "@mui/material";
import "@fontsource/roboto/300.css";
import "@fontsource/roboto/400.css";
import "@fontsource/roboto/500.css";
import "@fontsource/roboto/700.css";

// declare custom typography variants
declare module "@mui/material/styles" {
  interface TypographyVariants {
    code: React.CSSProperties;
  }
  interface TypographyVariantsOptions {
    code: React.CSSProperties;
  }
}

declare module "@mui/material/Typography" {
  interface TypographyPropsVariantOverrides {
    code: true;
  }
}

const typography: ThemeOptions["typography"] = (_palette) => ({
  fontSize: 14,
  fontFamily: `"Roboto","Helvetica","Arial",sans-serif`,
  code: {
    fontFamily: "monospace",
    whiteSpaceCollapse: "preserve",
  },
});

export default typography;
